angular.module 'zc.core'

.factory 'NotificationChannel', ($rootScope) ->
  service =
    requestStarted: ->
      $rootScope.$broadcast '$stateChangeStart'
    requestEnded: ->
      $rootScope.$broadcast '$stateChangeSuccess'
    onRequestStarted: ($scope, handler) ->
      $scope.$on '$stateChangeStart', (event) ->
        handler()
    onRequestEnded: ($scope, handler) ->
      $scope.$on '$stateChangeSuccess', (event) ->
        handler()
  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/notification_channel_service.js.coffee